export default __webpack_public_path__ + "static/3-6e0788332654fa38733e16670d1b5d43.jpeg";